import React from 'react'
import PropTypes from 'prop-types'
import { Form, Row, Col, Text, FormInput } from 'shared/components'

import * as styles from './styles'

const EventsFiltersComponent = ({ form }) => (
  <Form form={form}>
    <Row>
      <Col xs={12} sm={4}>
        <FormInput name="search" icon="search" placeholder="Search..." grayBg />
      </Col>
      <Col xs={12} sm={4}>
        <Row css={styles.inWinnableRowWrapper}>
          <Text as="label" size={11} css={styles.wrapperLabel}>
            Manually non-inWinnable only:
          </Text>
          <FormInput name="inWinnable" type="toggle" oldInput />
        </Row>
      </Col>
    </Row>
  </Form>
)

EventsFiltersComponent.propTypes = {
  form: PropTypes.shape().isRequired,
}

export default EventsFiltersComponent
